module.exports = __webpack_public_path__ + "assets/img/104.56be26d8.png";